var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"explain"},[_c('h1',[_vm._v(_vm._s(_vm.dataText.title))]),_vm._v(" "),_c('div',{staticClass:"content-explain",domProps:{"innerHTML":_vm._s(_vm.dataText.content)}})]),_vm._v(" "),_c('Lfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }